const UtilityBar = ({ 
  resultCount, 
  categories, 
  activeCategory, 
  onCategoryChange, 
  sortOption, 
  onSortChange 
}) => {
  return (
    <div className="border-b border-stone-200">
      <div className="max-w-screen-xl mx-auto px-6 py-4">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
          {/* Result Count */}
          <div className="text-sm text-stone-600">
            Showing {resultCount} {resultCount === 1 ? 'collection' : 'collections'}
          </div>

          {/* Category Filters */}
          <nav className="flex gap-6 overflow-x-auto" aria-label="Collection categories">
            {categories.map((category) => (
              <button
                key={category.value}
                onClick={() => onCategoryChange(category.value)}
                className={`text-sm font-medium whitespace-nowrap pb-1 border-b-2 transition-colors duration-200 ${
                  activeCategory === category.value
                    ? 'text-emerald-700 border-emerald-700'
                    : 'text-stone-600 border-transparent hover:text-stone-900'
                }`}
                aria-current={activeCategory === category.value ? 'page' : undefined}
              >
                {category.label}
              </button>
            ))}
          </nav>

          {/* Sort Dropdown */}
          <div className="flex items-center gap-2">
            <label htmlFor="sort-select" className="text-sm text-stone-600">
              Sort:
            </label>
            <select
              id="sort-select"
              value={sortOption}
              onChange={(e) => onSortChange(e.target.value)}
              className="text-sm border-0 border-b border-stone-300 bg-transparent text-stone-900 focus:outline-none focus:border-emerald-700 pr-8"
            >
              <option value="popularity">Popularity</option>
              <option value="newest">Newest</option>
              <option value="name-asc">Name: A-Z</option>
              <option value="name-desc">Name: Z-A</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UtilityBar;
